import type { ComponentStyle } from "@yamada-ui/core"

export const For: ComponentStyle<"For"> = {}
